import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import {Grid} from "@mui/material";

import Popup from "components/WMS/Mobile/Popup";
import CustomButton from "components/CustomButton";

import {ReactComponent as ExtractProduct} from "assets/img/wms/extractProduct.svg";

StopSortingPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
};

export default function StopSortingPopup({open, onConfirm, onCancel}) {
    return (
        <Popup
            open={open}
            onClose={onCancel}
            title={<FormattedMessage id={"wms.sorting.inSorting.stopSorting.title"}/>}
            subtitle={<FormattedMessage id={"wms.sorting.inSorting.stopSorting.subtitle"}/>}
            icon={<ExtractProduct/>}
        >
            <Grid container direction={"column"} gap={"16px"}>
                <Grid item>
                    <CustomButton onClick={onConfirm} fullWidth color={'default'}>
                        <FormattedMessage id={"wms.sorting.inSorting.stopSorting.validButton"}/>
                    </CustomButton>
                </Grid>
                <Grid item>
                    <CustomButton onClick={onCancel} fullWidth>
                        <FormattedMessage id={"wms.sorting.inSorting.stopSorting.cancelButton"}/>
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    )
}
